import { createRoute,lazyRouteComponent } from '@tanstack/react-router'

import { newsRoute } from '.'

const News = lazyRouteComponent(() => import('../../pages/news'))

export const newsListRoute = createRoute({
  getParentRoute: () => newsRoute,
  path: '/',
  component: News,
})
